import SocialProofABC from "images/social_proof_images/ABC.webp";
import SocialProofBI from "images/social_proof_images/Business Insider.webp";
import SocialProofCBS from "images/social_proof_images/CBS.webp";
import SocialProofCNBC from "images/social_proof_images/CNBC.webp";
import SocialProofCNET from "images/social_proof_images/CNET.webp";
import SocialProofFastCompany from "images/social_proof_images/Fast Company.webp";
import SocialProofForbes from "images/social_proof_images/Forbes.webp";
import SocialProofLAT from "images/social_proof_images/LAT.webp";
import SocialProofMastercard from "images/social_proof_images/Mastercard.webp";
import SocialProofMotleyFool from "images/social_proof_images/MotleyFool.webp";
import SocialProofNerdWallet from "images/social_proof_images/Nerdwallet.webp";
import SocialProofNYT from "images/social_proof_images/NYT.webp";
import SocialProofUSAToday from "images/social_proof_images/USA Today.webp";
import SocialProofWSJ from "images/social_proof_images/WSJ.webp";
import SocialProofYahoo from "images/social_proof_images/Yahoo.webp";

// list of images to be displayed at the AutoplayCarousel
// if adding/removing items, should update totalWidthPreload
export const socialProofImages = [
  { img: SocialProofABC, alt: "ABC" },
  { img: SocialProofBI, alt: "Business Insider" },
  { img: SocialProofCBS, alt: "CBS" },
  { img: SocialProofCNBC, alt: "CNBC" },
  { img: SocialProofCNET, alt: "CNET" },
  { img: SocialProofFastCompany, alt: "Fast Company" },
  { img: SocialProofForbes, alt: "Forbes" },
  { img: SocialProofLAT, alt: "LA Times" },
  { img: SocialProofMastercard, alt: "Mastercard" },
  { img: SocialProofMotleyFool, alt: "MotleyFool" },
  { img: SocialProofNerdWallet, alt: "NerdWallet" },
  { img: SocialProofNYT, alt: "New York Times" },
  { img: SocialProofUSAToday, alt: "USA Today" },
  { img: SocialProofWSJ, alt: "Wall Street Journal" },
  { img: SocialProofYahoo, alt: "Yahoo" },
];

export const formatCurrency = (value, options) =>
  value?.toLocaleString("en-US", {
    ...(options?.currencyDisplay !== "none" && {
      style: "currency",
      currency: "USD",
      currencyDisplay: options?.currencyDisplay || "symbol",
    }),
    maximumFractionDigits: options?.digits || 0,
    minimumFractionDigits: options?.digits || 0,
  });